import { Button } from '@consta/uikit/Button'
import type { FC } from 'react'

import css from './Footer.css'

type FooterProps = {
  onApply: () => void
  disabled?: boolean
}

export const Footer: FC<FooterProps> = ({ onApply, disabled }) => {
  return (
    <footer className={css.footer}>
      <Button label="Применить" size="xs" view="primary" disabled={disabled} onClick={onApply} />
    </footer>
  )
}
